module.exports = __webpack_public_path__ + "static/media/Icon-CV_Set 1_Skills_Bars Vertical.bd687a50.svg";